export const kr = {
  name: "kr" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M15.206 9.33h2.081v1.898c.256-.688.66-1.205 1.216-1.549.555-.355 1.22-.532 1.997-.532.223 0 .389.005.5.016v2.065a6.646 6.646 0 0 0-.55-.034c-.887 0-1.625.25-2.214.75-.588.488-.882 1.187-.882 2.097v3.613h-2.148V9.33ZM3 6h2.347v5.011L10.758 6h3.097l-6.077 5.577 6.56 6.077H11.09L5.347 12.41v5.244H3V6Z"/></svg>`,
  keywords: ["kr"],
  category: "finance" as const,
};
